import React, { useState, useEffect } from "react";
import httpClient from "../utils/httpClients";
import { useNavigate, useLocation, Link } from "react-router-dom";
import TopTost from "../utils/topTost";
import { toast } from "react-toastify";
import { messaging, getToken } from "../FirebaseConfig/firebase";
import { rtdb } from "../FirebaseConfig/firebase";
import { ref, set, serverTimestamp } from "firebase/database";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberedEmail");
    const savedPassword = localStorage.getItem("rememberedPassword");
    const savedRememberMe = localStorage.getItem("rememberMe") === "true";

    if (savedRememberMe && savedEmail && savedPassword) {
      setEmail(savedEmail);
      setPassword(savedPassword);
      setRememberMe(savedRememberMe);
    }
  }, []);

  const requestFirebaseToken = async () => {
    try {
      const currentToken = await getToken(messaging, {
        vapidKey:
          "BOU7hdQgLMfKMNENWVd5pQgopbu_jW6K83kgGzquuClXKV5hlqR6X90ZyuvOcs7hQ-iU3KsdTprO64R36mB8uDo",
      });

      if (currentToken) {
        localStorage.setItem("device_token", currentToken);
        console.log("FCM Token obtained:", currentToken);
      } else {
        console.log("No FCM token available. User may have denied permission.");
      }
    } catch (error) {
      console.error("FCM Token Error:", error);
      localStorage.setItem("device_token", "fallback_device_token");
    }
  };

  useEffect(() => {
    requestFirebaseToken();
  }, []);

  const setUserOnlineStatus = async (user) => {
    try {
      const userId = user.id || user._id;

      if (!userId) {
        console.error("No user ID found in user object");
        return;
      }

      const userStatusRef = ref(rtdb, `onlineStatus/${userId}`);

      await set(userStatusRef, {
        online: true,
        lastSeen: null,
        email: user.email,
        name: user.name || user.email.split("@")[0],
        userId: userId,
        profilePic: user.profilePic || "",
        lastOnline: null,
        updatedAt: Date.now(),
      });

      console.log("User online status updated in Firebase:", userId);
    } catch (error) {
      console.error("Error setting online status in Firebase:", error);
    }
  };

  /**
   * @param {boolean} checked - Whether the checkbox is checked
   */
  const handleRememberMe = (checked) => {
    setRememberMe(checked);

    if (!checked) {
      localStorage.removeItem("rememberedEmail");
      localStorage.removeItem("rememberedPassword");
      localStorage.removeItem("rememberMe");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    if (!email || !password) {
      TopTost.fire({
        icon: "error",
        title: "Please fill in all fields",
      });
      return;
    }

    setIsLoading(true);

    const device_token = localStorage.getItem("device_token");

    try {
      const userInfo = {
        email: email.trim(),
        password: password,
        userType: "User",
        isOnline: true,
        fcmToken: device_token,
      };

      console.log("Sending login request with:", userInfo);

      const res = await httpClient.post("common/auth/login", userInfo);

      if (res.data?.success) {
        localStorage.removeItem("VolumeAuthToken");
        //   toast.success(res.data.message, {
        //     autoClose: 3000,
        //     position: "top-right",
        //   });
      }

      const receivedToken = res.data?.data?.token;
      const receivedUser = res.data?.data?.user;
      const userTypes = Array.isArray(res.data?.data?.user?.userType)
        ? res.data.data.user.userType
        : res.data?.data?.user?.userType
          ? [res.data.data.user.userType]
          : [];
      const isOtpVerified =
        res.data?.data?.isOtpVerified ?? receivedUser?.isOtpVerified;

      if (rememberMe) {
        localStorage.setItem("rememberedEmail", email);
        localStorage.setItem("rememberedPassword", password);
        localStorage.setItem("rememberMe", "true");
      } else {
        localStorage.removeItem("rememberedEmail");
        localStorage.removeItem("rememberedPassword");
        localStorage.removeItem("rememberMe");
      }

      if (!isOtpVerified) {
        console.log("User requires OTP verification");
        localStorage.setItem("volumeAuthToken", res.data.data.token);
        navigate("/verify-otp", {
          state: {
            email: userInfo.email,
            type: "l",
            from: from,
          },
        });
        return;
      }

      if (receivedToken && receivedUser) {
        localStorage.setItem("volumeToken", receivedToken);
        localStorage.setItem("user", JSON.stringify(receivedUser));

        if (Array.isArray(userTypes)) {
          localStorage.setItem("userTypes", JSON.stringify(userTypes));
        }

        await setUserOnlineStatus(receivedUser);

        let destination;

        if (from && from !== "/") {
          destination = from;
          console.log("Redirecting to protected route:", destination);
        } else if (userTypes.includes("Artist")) {
          destination = "/artist/dashboard";
          localStorage.setItem("current_user", "Artist");
          console.log("Artist user, going to dashboard");
        } else {
          destination = "/";
          localStorage.setItem("current_user", "User");
          console.log("Regular user, going to home");
        }

        navigate(destination, {
          replace: true,
        });
      } else {
        throw new Error(
          "No authentication token or user data received from server",
        );
      }
    } catch (err) {
      console.error("Login error details:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
      });

      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        "Login failed. Please check your credentials and try again.";

      // TopTost.fire({
      //   icon: "error",
      //   title: errorMessage,
      // });
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  return (
    <div className="wrapper">
      <section className="login-content overflow-hidden">
        <div className="row no-gutters align-items-center bg-white">
          <div className="col-md-12 col-lg-6 align-self-center ">
            <a
              href="/"
              className="navbar-brand d-flex align-items-center mt-5 pt-5 mb-3 justify-content-center text-primary"
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
                alt="Logo"
                className="logo-img"
              />
            </a>

            <div className="row justify-content-center pt-5 px-4">
              <div className="col-md-9">
                <div className="card d-flex justify-content-center mb-0 auth-card iq-auth-form">
                  <div className="card-body">
                    <h2 className="mb-2 text-center">Sign In</h2>
                    <p className="text-center">Login to stay connected.</p>

                    <form onSubmit={handleSubmit} noValidate>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label htmlFor="email" className="form-label">
                              Email
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                              placeholder="xyz@example.com"
                              autoComplete="email"
                              disabled={isLoading}
                            />
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="form-group">
                            <label htmlFor="password" className="form-label">
                              Password
                            </label>
                            <div className="input-group">
                              <input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                minLength="6"
                                placeholder="xxxx"
                                autoComplete="current-password"
                                disabled={isLoading}
                              />
                              <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={togglePasswordVisibility}
                                disabled={isLoading}
                                aria-label={
                                  showPassword
                                    ? "Hide password"
                                    : "Show password"
                                }
                              >
                                <i
                                  className={`fa ${
                                    showPassword ? "fa-eye" : "fa-eye-slash"
                                  }`}
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-12 d-flex justify-content-between">
                          <div className="form-check mb-3">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="customCheck1"
                              checked={rememberMe}
                              onChange={(e) =>
                                handleRememberMe(e.target.checked)
                              }
                              disabled={isLoading}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="customCheck1"
                            >
                              Remember Me
                            </label>
                          </div>
                          <Link
                            to="/forgot-password"
                            className={isLoading ? "disabled-link" : ""}
                            onClick={(e) => isLoading && e.preventDefault()}
                          >
                            Forgot Password?
                          </Link>
                        </div>
                      </div>

                      <div className="d-flex justify-content-center">
                        <button
                          type="submit"
                          className="btn btn-primary btn-login"
                          disabled={isLoading}
                          aria-busy={isLoading}
                        >
                          {isLoading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              />
                              Signing In...
                            </>
                          ) : (
                            "Sign In"
                          )}
                        </button>
                      </div>

                      <p className="text-center my-3">
                        or sign in with other accounts?
                      </p>
                      <p className="mt-3 text-center">
                        Don't have an account?{" "}
                        <a href="sign-up" className="text-underline">
                          Click here to sign up.
                        </a>
                      </p>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 d-lg-block d-none bg-primary p-0 overflow-hidden">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/auth/01.jpg`}
              className="img-fluid gradient-main"
              alt="login background"
              loading="lazy"
              onError={(e) => {
                e.target.style.display = "none";
                e.target.parentElement.style.backgroundColor = "#4a6cf7";
              }}
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Login;
